// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1eMVI","title":"AfterFrontImage_title__zHa_e"};